import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import auditPro from "../../Assets/Projects/AuditPro.png";
import garimpeirosApp from "../../Assets/Projects/GarimpeirosApp.png";
import jobsFacilDashboard from "../../Assets/Projects/JobsfacilDashboard.png";
import nujobApp from "../../Assets/Projects/NujobApp.jpg";
import verticalMixDashboard from "../../Assets/Projects/VerticalMix.png";
import verticalMixApp from "../../Assets/Projects/VerticalMixApp.jpeg";
import { useTranslation } from "react-i18next";

function Projects() {
  const { t } = useTranslation();

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          {t("projects.headingBefore")}{" "}
          <strong className="purple">{t("projects.headingHighlight")} </strong>
        </h1>

        <p style={{ color: "white" }}>
          {t("projects.intro")}
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={garimpeirosApp}
              isBlog={false}
              title="Garimpeiros App"
              description={t("projects.items.garimpeiros")}
              demoLink="https://play.google.com/store/apps/details?id=br.com.garimpeiros.aplicativo&hl=pt_BR"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nujobApp}
              isBlog={false}
              title="NuJob App"
              demoLink="https://play.google.com/store/apps/details?id=app.nujob.us"
              description={t("projects.items.nujob")}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={verticalMixApp}
              isBlog={false}
              title="VerticalMix Survey App"
              description={t("projects.items.verticalMixApp")}
              demoLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={auditPro}
              isBlog={false}
              title="AuditPro"
              description={t("projects.items.auditPro")}
              demoLink="https://auditpro.app.br/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={verticalMixDashboard}
              isBlog={false}
              title="VerticalMix Dashboard"
              description={t("projects.items.verticalMixDashboard")}
              demoLink="https://dashboard.verticalmix.com.br/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jobsFacilDashboard}
              isBlog={false}
              title="JobsFácil Dashboard"
              description={t("projects.items.jobsFacilDashboard")}
              demoLink="https://app.jobsfacil.com.br/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
